import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {navigate} from '@reach/router'
import * as rest from '../../services'
import EditProfilePane from './EditProfilePane'
import * as ReactBootstrap from 'react-bootstrap'
import {User} from "../../api";
import UserDisplay from "./UserDisplay";
import {PasswordChangePage} from "./PasswordChangePage";
import {ESignature} from "../ESignature";
import {ChangeGSXTokenPage} from "./ChangeGSXTokenPage";

export const UserProfilePage = ({
                                    activeKey,
                                }) => {
    const [profile, setProfile] = useState<User>()
    const {user} = useSelector((state) => state.auth)
    const [activeTabKey, setActiveTabKey] = useState(activeKey || 'profile')

    const handleTabSelect = (key) => {
        setActiveTabKey(key)
        navigate(`/dashboard/profile/${key}`)
    }
    const getUserProfile = () => {
        new rest.UserService(user.url).makeGetRequest().then(
            (response) => {
                setProfile(response as unknown as User)
            },
            (errors) => {
            }
        )
    }

    useEffect(() => {
        getUserProfile()
    }, [getUserProfile])


    return (
        <ReactBootstrap.Tabs activeKey={activeTabKey} onSelect={handleTabSelect}>
            <ReactBootstrap.Tab eventKey="profile" title="My Profile">
                <ReactBootstrap.Col>
                    <div className="text-end">
                        <EditProfilePane user={profile} OnSuccess={(user) => getUserProfile()}/>
                    </div>
                    {profile && <UserDisplay user={profile}/>}
                </ReactBootstrap.Col>
            </ReactBootstrap.Tab>
            <ReactBootstrap.Tab eventKey="password" title="Change Password">
                <PasswordChangePage/>
            </ReactBootstrap.Tab>
            <ReactBootstrap.Tab eventKey="token" title="Change GSX Token">
                <ChangeGSXTokenPage/>
            </ReactBootstrap.Tab>


            <ReactBootstrap.Tab eventKey="esignature" title="E-signature">
                <ESignature hideTerms={true} type="user" url={user.url}/>
            </ReactBootstrap.Tab>
        </ReactBootstrap.Tabs>
    )
}
